import React, { PureComponent } from "react";
import { decimalsRound } from "../../services/utils";

class GreetingsText extends PureComponent {
  render() {
    const {
      round,
      team_grade,
      data,
      isFinished,
      role,
      first_name,
      last_name
    } = this.props;

    return (
      <div>
        <h3 className="dashboard__title">
          Hi {first_name} {last_name} <span>({role})</span>
        </h3>

        {!isFinished ? (
          <p className="dashboard__text">
            Below are the financial targets that your team needs to hit each
            year. <span className="dashboard__text_bold">Hit all targets</span>{" "}
            each year and you’ll score 100%.
          </p>
        ) : (
          <fragment>
            <p className="dashboard__text">
              As of Year {round}, your team was ranked the{" "}
              <span className="dashboard__text_highlighted">{data}</span> with a
              performance score of{" "}
              <span className="dashboard__text_highlighted">
                {decimalsRound(team_grade, 2)}%
              </span>
              !
            </p>
          </fragment>
        )}
      </div>
    );
  }
}

export default GreetingsText;



// WEBPACK FOOTER //
// ./src/components/dashboard/GreetingsText.js